import { useEffect, useState } from 'react';

import { classname } from 'tailwindcss-class-parser'
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from 'twyne-new.ui'

import PaletteColors from '@/components/builder/properties/Color/Palette';

import FormatterIcon from '../../components/FormatterIcon';
import { useBubbleTiptap } from '../Bubble';

export default function NewColorFormatter({ value, onClick, icon: Icon, tooltipText }) {
  const [color, setColor] = useState()
  const [open, setOpen] = useState(false)
  const { setBubblePopover } = useBubbleTiptap()

  useEffect(() => {
    setBubblePopover && setBubblePopover(open)
  }, [open, setBubblePopover])

  useEffect(() => {
    if (value === undefined && color) {
      setColor()
    }
  }, [value, color])

  const handleChange = newColor => {
    setColor(newColor)
    onClick(newColor)
  }

  const className = value ? classname({ ...value, important: true }) : ''

  return <>
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger>
        <FormatterIcon
          icon={Icon}
          tooltipText={tooltipText}
          className={className}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-[270px]'>
        <PaletteColors value={color} onChange={handleChange} />
      </DropdownMenuContent>
    </DropdownMenu>
  </>
}
